import { Modal, ModalBody } from '@postscript/components';
import useModalTracking from 'components/campaigns/useModalTracking';
import { FlowType, FlowWizardOption } from 'components/flowBuilder/types';
import { parseFlowType } from 'components/flowBuilder/utils/flows';
import { useRef } from 'react';
import { MODAL_TYPES, PRODUCT_AREAS } from 'utils/events';
import CreateFlowWizard from '../CreateFlowWizard';

interface ModalProps {
  flowType: FlowType;
  isOpen: boolean;
  onCancel: (from?: FlowWizardOption) => void;
}

export default function CreateFlowModal({
  flowType,
  isOpen,
  onCancel,
}: ModalProps): JSX.Element {
  const { isCampaign } = parseFlowType(flowType);

  const trackClose = useModalTracking({
    isOpen,
    modalType: isCampaign
      ? MODAL_TYPES.CREATE_CAMPAIGN
      : MODAL_TYPES.CREATE_AUTOMATION,
    productArea: PRODUCT_AREAS.FLOW_BUILDER,
  });

  const handleClose = () => {
    trackClose();
    onCancel();
  };

  const headerRef = useRef(null);

  return (
    <Modal
      data-testid={
        isCampaign ? 'create-campaign-modal' : 'create-automation-modal'
      }
      firstFocusableElement={headerRef}
      isOpen={isOpen}
      onCancel={handleClose}
      style={{ width: 'fit-content' }}
    >
      <ModalBody>
        <CreateFlowWizard flowType={flowType} />
      </ModalBody>
    </Modal>
  );
}
